/**
 * 高德地图 Expo Module 类型定义统一导出
 * 基于 Expo Modules API 重新设计
 */

// 通用类型
export type {
  Point,
  LatLng,
  LatLngPoint,
  MapPoi,
  LatLngBounds,
  CameraPosition,
  CameraUpdate,
  ColorValue,
  SDKConfig,
  PermissionStatus,
} from './common.types';

export { MapType } from './common.types';

// 地图视图类型
export type {
  LocationEvent,
  CameraEvent,
  MapViewProps,
  MapViewMethods,
  MapViewRef,
  ExpoGaodeMapModuleEvents,
} from './map-view.types';

// 定位类型
export type {
  Coordinates,
  ReGeocode,
  HeadingUpdate,
  LocationOptions,
  LocationListener,
  HeadingListener,
  GeoLanguage,
  LocationProtocol,
} from './location.types';

export {
  LocationAccuracy,
  LocationMode,
  CoordinateType,
} from './location.types';

// 覆盖物类型
export type {
  MarkerProps,
  PolylineProps,
  PolygonProps,
  CircleProps,
  HeatMapProps,
  MultiPointItem,
  MultiPointProps,
  ClusterParams,
  ClusterPoint,
  ClusterProps,
} from './overlays.types';

// 模块 facade 类型
export type { ExpoGaodeMapModule } from '../ExpoGaodeMapModule';

export type {
  AreaMaskOverlayProps,
  FitToCoordinatesOptions,
  RouteBounds,
  RouteOverlayProps,
  RoutePlaybackController,
  RoutePlaybackOptions,
  RoutePlaybackState,
  SmoothMoveEndEvent,
  SmoothMoveProgressEvent,
} from './route-playback.types';
